import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./ResetPassword.css";

function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_FLASK_API_URL}/reset-password/${token}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password: newPassword }),
      }
    );

    const data = await response.json();
    if (response.ok) {
      setMessage("Password updated successfully");
    } else {
      setError(data.error || "Something went wrong");
    }
  };

  return (
    <div className="reset-container">
      <h1>Reset Password</h1>

      <div className="reset-body">
        {error && <p style={{ color: "red" }}>{error}</p>}

        {message && (
          <div className="success-message">
            <p>{message}</p>
            <button onClick={() => navigate("/")} className="back-button">
              Back to Login
            </button>
          </div>
        )}

        {!message && (
          <form onSubmit={handleSubmit}>
            <div>
              <input
                type="password"
                placeholder="Enter your new password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
            </div>
            <div>
              <input
                type="password"
                placeholder="Confirm your new password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
            </div>
            <button type="submit">Reset Password</button>
          </form>
        )}
      </div>
    </div>
  );
}

export default ResetPassword;
